import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '📘',
    title: 'Módulo 1 — Base Segura',
    desc: 'Postura, comandos básicos, frenada, confianza desde cero.'
  }, {
    icon: '📗',
    title: 'Módulo 2 — Conexión Vial',
    desc: 'Manejo en tránsito, cambios de marcha, primeras rutas.'
  }, {
    icon: '📙',
    title: 'Módulo 3 — Desarrollo Técnico',
    desc: 'Curvas, frenada de emergencia, manejo en lluvia.'
  }, {
    icon: '📕',
    title: 'Módulo 4 — Dominio Completo',
    desc: 'Contra-dirección, frenada combinada, ruta larga.'
  }, {
    icon: '📓',
    title: 'Módulo 5 — Maestría en Ruta',
    desc: 'Trazada, manejo en grupo, travesías.'
  }, {
    icon: '📔',
    title: 'Módulo 6 — Kit Blindaje Total',
    desc: '24 checklists, diagnóstico preventivo, mantenimiento completo.'
  }];
  const includes = ['Guías listas para usar', 'Checklists de revisión', 'Errores típicos del motociclista argentino', 'Solucionario técnico completo'];
  return <section className="py-24 bg-surface border-y border-white/5" data-id="element-152">
      <div className="container mx-auto px-4" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="text-center mb-16" data-id="element-155">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-156">
              🏆 MEGA PACK MOTOCICLISTA™
            </h2>
            <p className="text-xl text-cyan font-medium" data-id="element-157">
              6 Módulos + 5 Bonos — Todo resuelto.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-158">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-159">
              <div className="bg-background p-8 rounded-2xl border border-white/10 hover:border-cyan/50 transition-colors group h-full" data-id="element-160">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-161">
                  {mod.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-162">
                  {mod.title}
                </h3>
                <p className="text-gray-400" data-id="element-163">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-164">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-165">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-166">
              Cada módulo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-167">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-cyan shrink-0" data-id="element-169" />
                  <span className="text-gray-200" data-id="element-170">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}